class User {
    static path = 'variables/user';
    static vueMethods = {
        'triggerUserPicker': ({bucket1, node}) => {
            // window.VueApp.container.itemPickerType = 'User';
            window.VueApp.$modal.show('litegraph-item-picker');
        },
        'saveUserPicker': ({item, node}) => {
            let data = item.split(' - ');
            let userID = data[0];
            node.properties.value = item.slice(userID.length + 3);
            node.properties.userID = parseInt(userID)
            window.VueApp.$modal.hide('litegraph-item-picker');
        }
    }

    constructor(mutator) {
        this.addOutput("value", "user,model");
        // this.widgets_up = true;
        this.bgcolor = '#fd754b';
        this.title = 'Xerocraft User';
        this.desc = 'Select a user';
        this.properties = {value: '', userID: 0, modelProperties: window.triggerInfo.models['user']}

        if(window.VueApp.container.graphStatus !== 'read_only') {
            this.addWidget("button", "Select User", null, (v) => {
                window.VueApp.$refs.triggerBuilder.itemPickerType = 'User';
                window.VueApp.$refs.triggerBuilder.runNodeMethod('triggerUserPicker', {
                    bucket1: this.properties.userID & ' - ' & this.properties.value,
                    node: this
                }, true);
            });
        }

    }

    onExecute() {
        this.setOutputData(0, this.properties["value"]);
    }

    getTitle() {
        if (this.flags.collapsed) {
            return this.properties.value;
        }
        return this.title;
    }

    onDrawBackground() {
        //show the current value
        this.outputs[0].label = this.properties["value"];
    }
}

module.exports = User
